<script setup lang="ts">

import { usePlayerOreStore } from '@/stores/playerOreStore.ts'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GFBSOreTrade from '@/components/Sections/Government/Finances/BalanceSheetDetails/OreTrade/GFBSOreTrade.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerOreStore = usePlayerOreStore()

</script>

<template>
  <StandardCard :title="t('government.finances.oreTrade.title')" top-padding="0" :no-padding="true">
    <div class="bg-metal-950 rounded p-0.5">
      <table class="w-full border-separate" style="border-spacing: 0 2px;">
        <tr v-for="[index,trade] in playerOreStore.tradeData" :key="index" class="bg-metal-900">
          <GFBSOreTrade v-if="trade.quantity>0" :quantity="trade.quantity" :to-ore-id="trade.toOreId" :from-ore-id="trade.fromOreId"/>
        </tr>
      </table>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>